/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pre_Comfort_And_Absence_TemperaturesInputs */



/**
* | output |
* | --- |
* | "Pre-comfort and Absence temperatures" |
*
* @param {Pre_Comfort_And_Absence_TemperaturesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const pre_comfort_and_absence_temperatures = /** @type {((inputs?: Pre_Comfort_And_Absence_TemperaturesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Comfort_And_Absence_TemperaturesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Pre-comfort and Absence temperatures")
	return /** @type {LocalizedString} */ ("Températures Pré-confort et Absence")
});